import { inPopDetailPage, utilTool, getQueryField } from './utils';

const globalData = {};

var elThemeStyle = document.getElementById('theme-style');
var mColorTheme =
    elThemeStyle &&
    elThemeStyle.innerHTML.match(/--color-theme:\s*([^:;]+?)\s*;/);

// 添加锚点配置
const defaultGlobalData = {
    registerUserType: 'BUYER',
    template: getQueryField('template') || 'standard',
    registration: {
        style: 'standard'
    },
    questionNaire: {
        style: 'standard'
    },
    themeColor: (mColorTheme && mColorTheme[1]) || '#03c9ff',
    hereApiKey:
        process.env.NODE_ENV !== 'production'
            ? '3Cna31BNpK4CkcWrjkbAafzz1Y3Pa_s3Z-aVBe10Uyg'
            : 'ossFwZuLtG6UBfU1nBYfnST0x6XhkGbLko7JKOhLYAA',
    scheduleAnchor: {
        name: 'schedule',
        loginCallback: null
    }
};

export const prepareData = function (data) {
    if (data === 'fetch') {
        return globalData;
    }
    for (let key in globalData) {
        if (globalData.hasOwnProperty(key)) {
            delete globalData[key];
        }
    }
    if (data) {
        Object.assign(globalData, defaultGlobalData, data);
    } else {
        try {
            const globalForm = document.getElementById('global');
            if (globalForm) {
                Object.assign(
                    globalData,
                    defaultGlobalData,
                    JSON.parse(
                        globalForm.value || globalForm.textContent || '{}'
                    )
                );
            }
        } catch (e) {
            console.error(e);
        }
    }
    if (globalData.rulesMap) {
        //change attribute name
        globalData.terminologyMap = globalData.rulesMap;
        delete globalData.terminologyMap;
    }
    globalData.template =
        (globalData.themeConfig || {}).templateValue || globalData.template;
    globalData.is_virtual_lead = utilTool.getCookie('is_virtual_lead')
        ? true
        : false;
    let thirdPartAuthor = globalData.thirdPartAuthor || {},
        fbid = thirdPartAuthor.facebookClientId,
        ggid = thirdPartAuthor.googleClientId;
    if (fbid && fbid != 0) {
        globalData.facebook = true;
        globalData.FBAppId = fbid;
    } else {
        globalData.facebook = false;
    }
    if (ggid && ggid != 0) {
        globalData.google = true;
        globalData.googleAppId = ggid;
    } else {
        globalData.google = false;
    }
    globalData.licenseName = globalData.licenseName || 'License ID: ';
    if (utilTool.isObject(globalData.lazyMode)) {
        globalData.lazyMode = globalData.lazyMode.lazyMode;
    }
    if (inPopDetailPage || globalData.lazyMode === undefined) {
        globalData.lazyMode = false;
    }

    //resolve track
    if (globalData.hasOwnProperty('lpTrack')) {
        if (globalData.lpTrack.ga) {
            globalData.track.ga = globalData.lpTrack.ga;
        }
        if (globalData.lpTrack.pixel) {
            globalData.track.pixel = globalData.lpTrack.pixel;
        }
    }
    if (globalData.map) {
        globalData.map.type = globalData.map.type || 'here';
    } else {
        globalData.map = {
            type: 'here'
        };
    }
    globalData.house = globalData.house || {};
    if (globalData.house.showListingPrice === undefined) {
        globalData.house.showListingPrice = globalData.soldPrice
            ? globalData.soldPrice.soldListingPriceMark == 1
            : true;
    }
    if (globalData.house.showSoldPrice === undefined) {
        globalData.house.showSoldPrice = globalData.soldPrice
            ? globalData.soldPrice.soldListingPriceMark == 1
            : true;
        if (
            globalData.soldPrice &&
            globalData.soldPrice.soldListingPriceMark == 2
        ) {
            globalData.house.showSoldPrice = true;
        }
    }
    if (globalData.house.showAgentName === undefined) {
        globalData.house.showAgentName = globalData.hideAgentName
            ? !globalData.hideAgentName.hideAgentName
            : true;
    }
    // 在详情页注册的用户均为seller
    // if (globalData.pageKey === 'listing-detail-sold') {
    //     globalData.registerUserType = 'SELLER';
    // }
    updateRegisterTypeByPageKey(globalData.pageKey);

    window.addEventListener('message', ({ data }) => {
        if (data.action === 'site_global_data') {
            Object.assign(globalData, data.data);
        }
    });
    if (!globalData.creatorId) {
        let creatorIdEl = document.getElementById('creatorId');
        globalData.creatorId = parseInt(creatorIdEl && creatorIdEl.value);
    }
    let evaluationSite = document.getElementById('evaluationSite');
    globalData.evaluationSite = parseInt(
        evaluationSite && evaluationSite.value
    );
    // globalData.openMultilingual = true; // 方便测试
    if (
        globalData.openMultilingual &&
        globalData.sysLanguageList &&
        globalData.sysLanguageList.length > 1
    ) {
        globalData.translatorType = 'chime';
    } else if (globalData.language && globalData.language.show) {
        globalData.translatorType = 'googlePlugin';
    }

    // globalData.wordPressSSR = true;
    // globalData.widget = false;

    return globalData;
};

// 根据purchaseType来修改 registerUserType (in md-detail-info created)
export function updateRegisterUserType(purchaseType,globalData) {
    // 记录registerUserType是否是通过purchaseType来设置的
    globalData.isRegUserTypeByPurchaseType = true;
    switch (purchaseType) {
        case 'For Sale':
            globalData.registerUserType = 'BUYER';
            break;
        case 'For Rent':
            globalData.registerUserType = 'RENTAL';
            break;
        case 'For Sold':
            globalData.registerUserType = 'SELLER';
            break;
        default:
            break;
    }
}

// 根据 globalData.pageKey 更新
let SELLER_PAGE_KEY = ['listing-detail-sold', 'sell', 'evaluation'];
export function updateRegisterTypeByPageKey(pageKey) {
    if (SELLER_PAGE_KEY.includes(pageKey)) {
        console.log('--updateRegisterTypeByPageKey----SELLER--');
        globalData.registerUserType = 'SELLER';
    }
}

//和服务端有关的数据
export default globalData;
